import React, { FC } from 'react';
import { RouteProp, useRoute } from '@react-navigation/native';
import { TWCPage } from '@components';

import { pictureDetailedVODPageTestIDs } from '@constants';

import { PictureDetailedVODContentAPI } from './PictureDetailedVODContentAPI/PictureDetailedVODContentAPI';

export const PictureDetailedVODPage: FC = () => {
  const { params } = useRoute<RouteProp<DetailedVODStack, 'PictureDetailedVODPage'>>();
  const { showID } = params;

  return (
    <TWCPage
      childIds={[
        pictureDetailedVODPageTestIDs.headerArea,
        pictureDetailedVODPageTestIDs.episodesTiles,
        pictureDetailedVODPageTestIDs.seasonsMenu,
        pictureDetailedVODPageTestIDs.readMoreButton,
        pictureDetailedVODPageTestIDs.restartButton,
      ]}
      firstFocus={pictureDetailedVODPageTestIDs.headerArea}
      isMenuItem={false}
      pageID={pictureDetailedVODPageTestIDs.pictureDetailedVODPage}
    >
      <PictureDetailedVODContentAPI data={{ showID }} />
    </TWCPage>
  );
};

type DetailedVODStack = {
  PictureDetailedVODPage: { showID: string | undefined; data: unknown; playlist?: unknown };
};
